// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Box_wrapper__3SKhe","draw":"Box_draw__23J9s","fill":"Box_fill__190E3","move":"Box_move__3YopK"};